module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mbnskms5-ac37a86c53c950152d4b617a79ea0012.jpg";